class KalonyaProductTabs {
  constructor(section) {
    this.section = section;
    this.buttons = Array.from(section.querySelectorAll('[data-tab-button]'));
    this.contents = Array.from(section.querySelectorAll('[data-tab-content]'));
    this.bundlePanels = Array.from(section.querySelectorAll('[data-bundle-detail-panel]'));
    this.currentTitle = section.querySelector('[data-bundle-current-title]');

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.activate(button.dataset.tabTarget));
    });

    document.addEventListener('kalonya:bundle-product-info', (event) => {
      this.activateBundleProduct(event.detail?.productId);
    });
  }

  activate(tabId) {
    this.buttons.forEach((button) => {
      const isActive = button.dataset.tabTarget === tabId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.contents.forEach((content) => {
      const isActive = content.dataset.tabContent === tabId;
      content.classList.toggle('is-active', isActive);
      content.hidden = !isActive;
    });
  }

  activateBundleProduct(productId) {
    if (!productId || this.bundlePanels.length === 0) return;

    let activeTitle = '';

    this.bundlePanels.forEach((panel) => {
      const isActive = panel.dataset.bundleProductId === productId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;

      if (isActive && !activeTitle) {
        activeTitle = panel.dataset.bundleProductTitle || '';
      }
    });

    if (activeTitle && this.currentTitle) {
      this.currentTitle.textContent = activeTitle;
    }

    this.activate('specifications');
    this.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function initKalonyaProductTabs() {
  document.querySelectorAll('[data-kalonya-product-tabs]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new KalonyaProductTabs(section);
  });
}

document.addEventListener('DOMContentLoaded', initKalonyaProductTabs);
document.addEventListener('shopify:section:load', initKalonyaProductTabs);
